/* enl-product.js — Loop-style product page logic (single/double/triple choice, add-ons, gallery, AJAX cart, buy now, local currency) */
(function () {
  function buildTriple(root, T) {
    var dbl = root.querySelector('[data-enl-mode="double"]');
    if (!dbl || root.querySelector('[data-enl-mode="triple"]')) return;
    var tr = dbl.cloneNode(true);
    tr.setAttribute('data-enl-mode', 'triple');
    tr.classList.remove('is-active');
    tr.setAttribute('aria-checked', 'false');
    var nm = tr.querySelector('.enl-opt-card__name'); if (nm) nm.textContent = T.label || 'Triple';
    var x = tr.querySelector('.enl-choice__x2'); if (x) x.textContent = '×3';
    var cp = tr.querySelector('[data-enl-cardprice]'); if (cp) { cp.setAttribute('data-enl-cardprice', 'triple'); cp.textContent = ''; }
    var note = tr.querySelector('.enl-choice__note'); if (note) note.textContent = T.note || '';
    var body = tr.querySelector('.enl-choice__body');
    var subs = body ? body.querySelectorAll('.enl-choice__sub') : [];
    var pick2 = body ? body.querySelector('[data-enl-pickers="b2"]') : null;
    if (body && subs.length && pick2) {
      var sub3 = subs[subs.length - 1].cloneNode(true);
      sub3.textContent = T.third || 'Item 3';
      var pick3 = pick2.cloneNode(true);
      pick3.setAttribute('data-enl-pickers', 'b3');
      pick3.querySelectorAll('[data-enl-set]').forEach(function (el) { el.setAttribute('data-enl-set', 'b3'); });
      pick3.querySelectorAll('select').forEach(function (s) { s.id = s.id.replace('-b2-', '-b3-'); });
      pick3.querySelectorAll('label[for]').forEach(function (l) { l.setAttribute('for', l.getAttribute('for').replace('-b2-', '-b3-')); });
      body.appendChild(sub3);
      body.appendChild(pick3);
    }
    tr.querySelectorAll('select').forEach(function (s) { s.id = 't-' + s.id; });
    tr.querySelectorAll('label[for]').forEach(function (l) { l.setAttribute('for', 't-' + l.getAttribute('for')); });
    dbl.parentNode.insertBefore(tr, dbl.nextSibling);
  }

  function initPdp(root) {
    if (root.dataset.enlReady) return;
    root.dataset.enlReady = '1';
    var T = window.ENL_TRIPLE;
    if (T) buildTriple(root, T);
    var product = JSON.parse(root.querySelector('[data-enl-product]').textContent);
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var atcLabel = root.dataset.atcLabel || 'Add to cart';
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    function localBundle(cents) {
      cents = parseInt(cents || '0', 10) || 0;
      if (cents > 0 && rate !== 1) cents = Math.ceil(cents * rate / 100) * 100 - 5;
      return cents;
    }
    var doublePrice = localBundle(root.dataset.doublePrice);
    var triplePrice = T ? localBundle(T.cents) : 0;
    var fmt = null;
    (function () {
      var el = root.querySelector('[data-enl-now]');
      var m = el && el.textContent.trim().match(/^(.*?)(\d{1,3}(?:([.,\s '])\d{3})*)(?:([.,])(\d{2}))?(.*)$/);
      if (!m) return;
      var dec = m[4] || '', thou = m[3] || (dec === ',' ? '.' : ',');
      fmt = { pre: m[1], post: m[6], dec: dec, thou: thou, decimals: !!dec };
    })();
    function money(cents) {
      if (fmt) {
        var v = (cents / 100).toFixed(fmt.decimals ? 2 : 0).split('.');
        var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thou);
        return fmt.pre + whole + (fmt.decimals ? fmt.dec + v[1] : '') + fmt.post;
      }
      var v2 = (cents / 100).toFixed(2), parts = v2.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return withCommas;
        if (k === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
        return withCommas + '.' + parts[1];
      });
    }
    function imgUrl(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
    function $(s) { return root.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

    var idInput = $('[data-enl-variant-id]');
    var start = product.variants.find(function (v) { return v.id == idInput.value; }) || product.variants[0];
    var sets = { a: start.options.slice(), b1: start.options.slice(), b2: start.options.slice(), b3: start.options.slice() };
    var mode = 'single';

    function matchOpts(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function lineItems() {
      var keys = mode === 'double' ? ['b1', 'b2'] : (mode === 'triple' ? ['b1', 'b2', 'b3'] : ['a']);
      return keys.map(function (k) { return matchOpts(sets[k]); });
    }

    function quote(vs) {
      var regular = vs.reduce(function (t, v) { return t + v.price; }, 0);
      if (mode === 'double' && doublePrice > 0) return { price: doublePrice, compare: regular };
      if (mode === 'triple' && triplePrice > 0) return { price: triplePrice, compare: regular };
      var compare = vs.reduce(function (t, v) { return t + (v.compare_at_price || v.price); }, 0);
      return { price: regular, compare: compare };
    }

    function update(clickedSet) {
      $$('[data-enl-opt]').forEach(function (b) {
        var s = b.dataset.enlSet, idx = +b.dataset.enlOpt;
        b.classList.toggle('is-active', sets[s][idx] === b.dataset.value);
        var test = sets[s].slice(); test[idx] = b.dataset.value;
        var m = matchOpts(test);
        b.classList.toggle('is-unavailable', !m || !m.available);
      });
      $$('[data-enl-optlabel]').forEach(function (l) { l.textContent = sets[l.dataset.enlSet][+l.dataset.enlOptlabel]; });
      $$('.enl-pick--select').forEach(function (p) {
        var b = p.querySelector('[data-enl-opt]'), sel = p.querySelector('select');
        if (b && sel) sel.value = sets[b.dataset.enlSet][+b.dataset.enlOpt];
      });

      var va = matchOpts(sets.a), vb1 = matchOpts(sets.b1), vb2 = matchOpts(sets.b2), vb3 = matchOpts(sets.b3);
      var cs = $('[data-enl-cardprice="single"]');
      if (cs && va) cs.textContent = money(va.price);
      var cd = $('[data-enl-cardprice="double"]');
      if (cd && vb1 && vb2) {
        var reg = vb1.price + vb2.price;
        cd.innerHTML = doublePrice > 0 ? money(doublePrice) + ' <s>' + money(reg) + '</s>' : money(reg);
      }
      var ct = $('[data-enl-cardprice="triple"]');
      if (ct && vb1 && vb2 && vb3) {
        var reg3 = vb1.price + vb2.price + vb3.price;
        ct.innerHTML = triplePrice > 0 ? money(triplePrice) + ' <s>' + money(reg3) + '</s>' : money(reg3);
      }
      if (va && va.featured_image) { var t = $('[data-enl-thumb="a"]'); if (t) t.innerHTML = '<img src="' + imgUrl(va.featured_image.src, 300) + '" alt="">'; }
      if (vb1 && vb1.featured_image) { $$('[data-enl-thumb="b1"] img').forEach(function (t2) { t2.removeAttribute('srcset'); t2.src = imgUrl(vb1.featured_image.src, 300); }); }

      var vs = lineItems();
      var ok = vs.every(function (v) { return !!v; });
      var avail = ok && vs.every(function (v) { return v.available; });
      var atc = $('[data-enl-atc]'), sbtn = $('[data-enl-sticky-btn]');
      atc.disabled = !avail; atc.textContent = !ok ? 'Unavailable' : (avail ? atcLabel : 'Sold out');
      if (sbtn) sbtn.disabled = !avail;
      var bnow = $('[data-enl-buynow]'); if (bnow) bnow.disabled = !avail;
      if (!ok) return;
      idInput.value = vs[0].id;

      var q = quote(vs), sale = q.compare > q.price;
      $('[data-enl-price]').classList.toggle('is-sale', sale);
      $('[data-enl-now]').textContent = money(q.price);
      $('[data-enl-was]').textContent = sale ? money(q.compare) : '';
      $('[data-enl-save]').textContent = sale ? 'Save ' + Math.floor((q.compare - q.price) * 100 / q.compare) + '%' : '';
      var sn = $('[data-enl-sticky-now]'), sw = $('[data-enl-sticky-was]');
      if (sn) sn.textContent = money(q.price);
      if (sw) sw.textContent = sale ? money(q.compare) : '';

      if (clickedSet) {
        var cv = matchOpts(sets[clickedSet]);
        if (cv && cv.featured_media) {
          var item = $('[data-media-id="' + cv.featured_media.id + '"]'), gal = $('[data-enl-gallery]');
          if (item && gal) {
            if (window.innerWidth < 990) gal.scrollTo({ left: item.offsetLeft - gal.offsetLeft - 16, behavior: 'smooth' });
            else if (item !== gal.firstElementChild) gal.insertBefore(item, gal.firstElementChild);
          }
        }
        if (mode === 'single') {
          var url = new URL(window.location.href); url.searchParams.set('variant', vs[0].id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    function setMode(m, silent) {
      mode = m;
      $$('[data-enl-mode]').forEach(function (c) {
        var on = c.dataset.enlMode === m;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (!silent) update();
    }
    $$('[data-enl-opt]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var s = b.dataset.enlSet;
        sets[s][+b.dataset.enlOpt] = b.dataset.value;
        var card = b.closest('[data-enl-mode]');
        setMode(card ? card.dataset.enlMode : (s === 'a' ? 'single' : 'double'), true);
        update(s);
      });
    });
    $$('[data-enl-mode]').forEach(function (c) {
      c.addEventListener('click', function () { if (mode !== c.dataset.enlMode) setMode(c.dataset.enlMode); });
      c.addEventListener('keydown', function (e) {
        if (e.target === c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); setMode(c.dataset.enlMode); }
      });
    });

    $$('[data-enl-addon]').forEach(function (row) {
      var val = row.querySelector('[data-enl-qty-val]');
      var minus = row.querySelector('[data-enl-qty-minus]'), plus = row.querySelector('[data-enl-qty-plus]');
      var toggle = row.querySelector('[data-enl-addon-toggle]');
      function render() {
        var n = +row.dataset.qty;
        val.textContent = n; minus.disabled = n <= 0; plus.disabled = n >= 10;
        row.classList.toggle('is-on', n > 0);
        if (toggle) toggle.setAttribute('aria-checked', n > 0 ? 'true' : 'false');
      }
      function flip() { row.dataset.qty = +row.dataset.qty > 0 ? 0 : 1; render(); }
      minus.addEventListener('click', function (e) { e.stopPropagation(); row.dataset.qty = Math.max(0, +row.dataset.qty - 1); render(); });
      plus.addEventListener('click', function (e) { e.stopPropagation(); row.dataset.qty = Math.min(10, +row.dataset.qty + 1); render(); });
      row.addEventListener('click', function (e) { if (!e.target.closest('.enl-qty')) flip(); });
      if (toggle) toggle.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
      render();
    });

    update();

    var g = $('[data-enl-gallery]'), dots = $$('[data-enl-gallery-dots] span');
    function isDesktop() { return window.innerWidth >= 990; }
    function slideIndex() { return Math.round(g.scrollLeft / (g.firstElementChild.offsetWidth + 8)); }
    if (g && dots.length) g.addEventListener('scroll', function () {
      var i = slideIndex();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
    function step(dir) {
      if (!g || g.children.length < 2) return;
      if (isDesktop()) {
        if (dir > 0) g.appendChild(g.firstElementChild);
        else g.insertBefore(g.lastElementChild, g.firstElementChild);
      } else {
        var n = g.children.length, i = (slideIndex() + dir + n) % n, item = g.children[i];
        g.scrollTo({ left: item.offsetLeft - g.offsetLeft - 16, behavior: 'smooth' });
      }
    }
    var prevBtn = $('[data-enl-gal-prev]'), nextBtn = $('[data-enl-gal-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (g) g.addEventListener('click', function (e) {
      var item = e.target.closest('.enl-gallery__item');
      if (!item || e.target.closest('video[controls], iframe')) return;
      if (isDesktop() && item !== g.firstElementChild) { g.insertBefore(item, g.firstElementChild); return; }
      var r = item.getBoundingClientRect();
      step(e.clientX < r.left + r.width / 2 ? -1 : 1);
    });

    var ugc = $('[data-enl-ugc]'), next = $('[data-enl-ugc-next]');
    if (ugc && next) next.addEventListener('click', function () { ugc.scrollBy({ left: ugc.clientWidth * .7, behavior: 'smooth' }); });
    $$('.enl-ugc__card video').forEach(function (vid) {
      var play = vid.parentElement.querySelector('.enl-gallery__play');
      vid.parentElement.addEventListener('click', function () {
        if (vid.paused) { vid.muted = false; vid.play(); if (play) play.style.display = 'none'; }
        else { vid.pause(); if (play) play.style.display = ''; }
      });
    });

    var form = $('[data-enl-form]'), err = $('[data-enl-error]');
    var root_ = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var cartUrl = root_ + 'cart';
    function addToCart(goCheckout) {
      var atc = $('[data-enl-atc]'), bnow = $('[data-enl-buynow]');
      var vs = lineItems();
      if (!vs.every(function (v) { return v && v.available; })) return;
      var items = [];
      vs.forEach(function (v) {
        var ex = items.find(function (i) { return i.id === v.id; });
        if (ex) ex.quantity += 1; else items.push({ id: v.id, quantity: 1 });
      });
      $$('[data-enl-addon]').forEach(function (row) {
        var n = +row.dataset.qty;
        if (n > 0) items.push({ id: +row.dataset.variant, quantity: n });
      });
      atc.disabled = true; if (bnow) bnow.disabled = true; err.classList.remove('is-visible');
      var drawer = goCheckout ? null : document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; } catch (e) {}
      }
      fetch(cartUrl + '/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { atc.disabled = false; if (bnow) bnow.disabled = false; err.textContent = res.j.description || res.j.message || 'Could not add to cart.'; err.classList.add('is-visible'); return; }
          if (goCheckout) { window.location.href = root_ + 'checkout'; return; }
          atc.disabled = false; if (bnow) bnow.disabled = false;
          try {
            if (drawer && drawer.renderContents && res.j.sections) {
              var first = res.j.items ? res.j.items[0] : res.j;
              drawer.classList.remove('is-empty');
              drawer.renderContents(Object.assign({}, first, { sections: res.j.sections }));
              return;
            }
          } catch (e) {}
          window.location.href = cartUrl;
        })
        .catch(function () { window.location.href = goCheckout ? root_ + 'checkout' : cartUrl; });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    var buyNow = $('[data-enl-buynow]');
    if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });

    var sticky = $('[data-enl-sticky]');
    if (sticky) {
      $('[data-enl-sticky-btn]').addEventListener('click', function () { addToCart(false); });
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
  }

  function initAll() { document.querySelectorAll('[data-enl-pdp]').forEach(initPdp); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
